export const SaveGameVideoIds = {
    GAME_INTRO: "game_intro",
    GAME_OUTRO: "game_outro",
};